export const CALENDLY_URL = "https://tidycal.com/intimacyforcouples/alignment-call-with-aaron";

// Spiral Analysis booking links
export const SPIRAL_URL = "https://tidycal.com/team/aaron/spiral-analysis";
export const LASER_URL = "https://tidycal.com/team/aaron/free-15-min-lazercall";

// Section 8 carousel. Caption = the image filename without its extension.
export const CAROUSEL_PHOTOS = [
  { src: "/carousel-beastmode.jpg", caption: "Beastmode Retreat Leader" },
  { src: "/carousel-consciouskings.jpg", caption: "Conscious Kings Retreat" },
  { src: "/carousel-couplesworkshop.jpg", caption: "Couples Workshop with Greer" },
  { src: "/carousel-couplesretreat.jpg", caption: "Couples Retreat" },
  { src: "/carousel-warrior.jpg", caption: "Integrated Warrior Retreat" },
  { src: "/carousel-awakened.jpg", caption: "Awakened Brotherhood Hobart" },
  { src: "/carousel-archetypes.jpg", caption: "Masculine Archetypes Constellation" },
  { src: "/carousel-byron.jpg", caption: "Workshop in Byron Bay" },
];

export const FAQ_ITEMS = [
  {
    q: "Is this therapy, and how does it differ?",
    a: "No. I'm trained in Relational Life Therapy, so the depth and rigour of that training is in everything I do — but this isn't clinical treatment, and I'm not operating as your therapist here. Therapy tends to focus on healing the past and managing what's wrong. This work is about that and more — it's forward-facing: building the capacity, discipline and embodiment to actually become the man you're capable of being. If you're in crisis or need clinical mental health support, this isn't the right container, and I'll tell you that straight if it comes up on the call.",
  },
  {
    q: "Do I need to be \u201cspiritual\u201d for this to work?",
    a: "No. Some of the men I work with have never sat in ceremony or read a single spiritual book. Others have done it all and still feel ungrounded. Both doors lead here. What matters is whether you're actually ready to do the work, not what language you use to describe it.",
  },
  {
    q: "How is this different from a course or a book?",
    a: "Courses and books give you information. This work is calibrated to you — your specific stage of development, your specific patterns, delivered in a way that actually lands rather than just sounding good for a week. That's the whole point of using developmental models instead of a one-size-fits-all curriculum.\n\nYou also get session notes and worksheets after every session. Nothing gets lost — every key point raised gets captured, along with further self-reflection questions to take the work deeper between sessions. By the end of our time together, you'll have a tailor-made workbook documenting the entire arc of your progress. That's yours to keep and reference for the rest of your life.",
  },
  {
    q: "What's the actual commitment?",
    a: "3 or 6 months, depending on what we agree is right for you on the call. New clients currently get a 6-for-5 session offer — I've found 6 sessions is enough to create a meaningful breakthrough and give you a proper experience of the work.\n\nI don't offer one-off calls for new clients. I'm not interested in people who are only dabbling. If you've worked with me before, you're welcome to book in for one-off sessions. Full pricing is shared on the call, once we both know what we're actually working with.",
  },
  {
    q: "Do I work with women?",
    a: "Yes — selectively. The women who come to me are looking for something specific. They want to build genuine strength and resilience from the inside out. They want to feel confident, grounded and powerful in who they are.\n\nIf that's you, we're probably a good fit. Book an alignment call and we'll find out.",
  },
];

export const THE_WORK = [
  {
    title: "Relationship to Self",
    body: "Every relationship in your life is a reflection of the one you have with yourself. This is where we start; building the inner authority, self-respect and groundedness that makes every other relationship possible. You can't love well from an empty or unstable centre.",
  },
  {
    title: "Authenticity & Integrity",
    body: "Honouring and living your truth means dismantling every way you lie to yourself and subtly deceive others. You'll discover the freedom of truly accepting who you are, and the relief of no longer needing to prove yourself to anyone.",
  },
  {
    title: "Emotional Mastery & Embodiment",
    body: "Emotions can only be truly accessed through the body, not processed from inside your head. We cultivate genuine emotional intelligence; the capacity to feel what's actually there and express it in ways that build connection rather than destroy it.",
  },
  {
    title: "Relationship Mastery",
    body: "Drawing on over a decade of work as a relationship therapist and intimacy coach, you'll receive tailored guidance to navigate your most significant relationship challenges. The skills you build here serve every relationship in your life: your partner, your children, your friendships, your work, and above all, yourself.",
  },
];

export const TESTIMONIALS = {
  matteo: {
    name: "Matteo",
    role: "Somatic Trauma Healing Therapist",
    location: "Italy",
    photo: "/matteo.jpg",
    quote:
      "I wasn't lacking information — I had plenty of that. What I was missing was ground to stand on. That question changed things for me.",
    full: [
      "Working with Aaron came at a moment when I was genuinely lost. Not lacking information — I had plenty of that. What I was missing was ground to stand on.",
      "He gave me structure I could actually lean on. A clear framework, a masculine one, that helped me orient during a time of real confusion and transition.",
      "What I appreciated most was how he held depth and clarity together. He understood the psychological complexity of what I was going through — and then brought it back to something simple: integrity, self-respect, having standards, knowing your worth. That combination is rare, and it worked.",
      "He doesn't let you stay comfortable in your own analysis. He sees through it — gently but directly — and brings you back to the question that actually matters: what would a man who respects himself do here?",
      "That question changed things for me.",
    ],
  },
  dom: {
    name: "Dom",
    role: "Physiotherapist",
    location: "Australia",
    photo: "/dom.jpg",
    quote:
      "I can back myself a lot more. I have more self-worth and self-respect. Just jump in and do it.",
    full: [
      "Coming into this I wasn't sure what to expect — or what I might uncover about myself. But committing to the process opened up parts of my psyche that were either in the shadow, that I didn't want to face, or that I didn't even know were there.",
      "The biggest thing I've taken away is feeling truly authentic in my decision making. I can back myself a lot more. I have more self-worth and self-respect. And I'm now able to make decisions with clarity and confidence — without the overthinking — knowing that if I trust myself, it's going to lead to the outcome I actually desire.",
      "I can't recommend it enough. Just jump in and do it.",
    ],
  },
  andrew: {
    name: "Andrew",
    role: "Tattoo Artist",
    location: "Australia",
    photo: "/andrew.jpg",
    quote:
      "Without this work I wouldn't have the understanding or the permission to be who I truly am. Aaron will go first — that courage is what makes it possible for you to follow.",
    full: [
      "There have been so many aspects of myself that I had really limited awareness of. Aaron gave me the space to share my vulnerability — and with that, the most valuable perspectives. Together we shone a light on where the truth really sits with the things that had been sitting in my shadow, creating distortion in my perception and my behaviour.",
      "Every single session was incredibly potent. He held such a safe space to be vulnerable in. Multiple times throughout each call there were moments of utter relief as I gained understanding of what had actually been going on within myself.",
      "Without this work, I wouldn't have the understanding or the permission to be who I truly am — to the level I am right now.",
      "And to any man standing on the sidelines: Aaron will go first. He'll show you how to do it through his own vulnerability and rawness — even when he doesn't have to. That courage of stepping in first is what makes it possible for you to follow.",
    ],
  },
  damian: {
    name: "Damian",
    role: "Musician",
    location: "Australia",
    photo: "/damian.jpg",
    quote:
      "I'd accomplished more in three months than I had in three to four years with psychologists and psychiatrists combined. Can you put a price on that?",
    full: [
      "I'd done everything western medicine had to offer — psychologists, social workers, psychiatrists, psychiatric hospitals. Years of it. None of it remotely helped.",
      "After three months working with Aaron, I'd accomplished more than I had in three to four years with all of that combined.",
      "What I love about this work is the holistic approach — it doesn't dismiss western psychology, but it also brings in the eastern side of things. The stuff I used to write off as 'hippie' and 'quirky spirituality'? That's the stuff that actually holds the power to heal. That's the stuff that creates real self-awareness.",
      "Coming from a very masculine, egotistic family and twelve years in the army, I've been able to realise that it's coming from an open heart and love — that's where everything good happens.",
      "To anyone sitting on the fence about the investment: can you put a price on ultimate happiness, self-forgiveness, and a better relationship with yourself, your partner, your children? Nothing will come until you work on you. Just do it. Jump in.",
    ],
  },
  adam: {
    name: "Adam",
    role: "Boat Builder & Photographer",
    location: "Australia",
    photo: "/adam.jpg",
    quote:
      "Let the truth do the magic. If you've got the guts to show up and face all of that — this is the work for you.",
    full: [
      "I knew from the little I'd looked into it — and my trust in Aaron — that it was the right path for me. I had a lot of stuff I was moving through and needed to find understanding and depth within it.",
      "Working through the structure one step at a time, I was able to sink to the core of where things were at — and understand through my own truth and integrity how best to move them through me and out into the world. To clear what needed clearing.",
      "What I really loved was being met in the heart space with empathy and compassion. Not being pushed toward a particular outcome. No bias. This was my journey, my story. And I was given the skills and the space to let my own truth come through.",
      "Let the truth do the magic — that's what this work does.",
      "To any man teetering on the decision: how ready are you to dive deep and access the hidden layers? If you've got the guts to show up and face all of that — with the chance that it might clear it all — then this is the work for you.",
    ],
  },
  annabel: {
    name: "Annabel-Lee",
    role: "Mother of One",
    location: "",
    photo: "/annabel-lee.jpg",
    quote:
      "Aaron provides a really strong container for self discovery. If you are seeking grounded, clear and non-judgemental support, you have come to the right place.",
    full: [
      "When I first started working with Aaron, I was feeling really uncertain, small, unsure and a little bit crazy.",
      "I gained a lot of clarity through the work we did. Like a laser pointer, Aaron guided me towards focusing on my own sense of personal integrity and how I could build trust in myself through action. The flow-on affect of that has been beautiful and inspiring in so many ways. Yes! I am inspired by myself \uD83D\uDE0A",
      "Aaron provides a really strong container for self discovery. If you are seeking grounded, clear and non-judgemental support from someone who truly embodies the father archetype, then you have come to the right place.",
    ],
  },
};

export const LINEAGE = [
  "Certified Relational Life Therapy (RLT) Therapist",
  "Certified Life Coach (TCI)",
  "Certified Intimacy & Polarity Practitioner — Michaela Boehm and Steve James",
  "Certified THETA Healing Practitioner",
  "Certified Cacao Practitioner",
  "Ongoing study and facilitation in Family Constellations",
];
